import * as React from 'react';
import {
  TopWrapper,
  Header,
  Wrapper,
  InsideWrapper,
  HeaderWrapper,
  WarningContent,
  Link,
} from './WarningInsideBubble.css';
import WarningIcon from './WarningIcon';

/* Helpers */
export const warningHref = 'www.P65Warnings.ca.gov';
const warningHrefHttps = `https://${warningHref}`;
export const warningInsideBubble =
  'This product can expose you to chemicals including Nickel (Metallic) which is known to the State of California to cause cancer.';

/* Components */
const MoreInformationLinkSentence: React.FunctionComponent = () => (
  <>
    {' '}
    For more information go to{' '}
    <Link href={warningHrefHttps} target="_blank">
      {warningHref}
    </Link>
    .
  </>
);

export const WarningInsideBubble: React.FunctionComponent = () => (
  <Wrapper data-cy="bubble-content">
    <InsideWrapper>
      <TopWrapper>
        <WarningIcon />
        <HeaderWrapper>
          <Header>Warning:</Header>
        </HeaderWrapper>
      </TopWrapper>
      <WarningContent>
        {warningInsideBubble}
        <MoreInformationLinkSentence />
      </WarningContent>
    </InsideWrapper>
  </Wrapper>
);

export default WarningInsideBubble;
